import { Popover, Panel, FormGroup, FormControl, HelpBlock, Button} from 'react-bootstrap';
import React from 'react';
import {SSkills, PProjects, WWorkExperience, EEducation} from './Home';

export default class Terminal extends React.Component{
constructor(props){
	super(props);
	this.state={
		show:true,
		showPanel:true,
		showSkills:false,
		showProject:false,
		showEducation:false,
		showWork:false,
		showWarning:false,
		showToggle:false,
		value:"",
		terminalText:`s for skills, w for work experience, e for education, p for projects \r`,
		terminalOut:`root: kmishra$ `,
		terminalOut2: `root: kmishra$ `
	}
}
componentDidMount(){
	
	document.getElementById("formBasicText").setAttribute("autocomplete", "off");
	
}
handleChange(e) {
    this.setState({ value: e.target.value,
    	terminalOut:'',
    	show:false});

    if(e.target.value[e.target.value.length-1]==="e"){
    	console.log("e");
    	this.setState({
    		showEducation:true,
    		showSkills:false,
			showProject:false,
			showWork:false,
    	});
    	document.getElementById("popover-basic").style.display='none';
    }
    else if(e.target.value[e.target.value.length-1]==="s"){
    	this.setState({
    		showSkills:true,
			showProject:false,
			showEducation:false,
			showWork:false,
    	});
    	document.getElementById("popover-basic").style.display='none';

    }
    else if(e.target.value[e.target.value.length-1]==="w"){
    	this.setState({
    		showWork:true,
    		showSkills:false,
			showProject:false,
			showEducation:false,
    	});
    	document.getElementById("popover-basic").style.display='none';

    }
    else if(e.target.value[e.target.value.length-1]==="p"){
    	this.setState({
    		showProject:true,
    		showSkills:false,
			showEducation:false,
			showWork:false,
    	});
    	document.getElementById("popover-basic").style.display='none';

    }
    else{

    	this.setState({showWarning:true});
    	document.getElementById("popover-basic").style.display='block';
    }

  }
onKeyDown(e){
	if(e.target.value.length < this.state.terminalOut2.length){
		const testStr=this.state.terminalOut2 + ' ';
		this.setState({
			value: testStr,
			});
		}
	}
close(){
	this.setState({showPanel: !this.state.showPanel,
					show: true,
					showWarning: !this.state.showWarning,
					showToggle: !this.state.showToggle});
}

render(){
	const headerComponent =(
		<h3>
			Use this terminal to filter out each section <em>(just a Linux style component I built for web apps for sorting child components)</em>
			<Button bsStyle="warning pull-right btn-circle" onClick={this.close.bind(this)} type="reset">
			{		
					this.state.showToggle?
					<i className="fa fa-toggle-up" aria-hidden="true"></i>:
					<i className="fa fa-times" aria-hidden="true"></i>
					
					
			}
			</Button>
		</h3>
		);
	return(
	<div>
	{
    	this.state.show ?
    	<div>
	        	<SSkills/>
	        	<WWorkExperience/>
	        	<EEducation/>
	        	<PProjects/>
	        	<hr className="break"/>
	        </div>
	        : null
        	
    }
		<Panel
		collapsible expanded={this.state.showPanel}
		bsStyle="default"
		header={headerComponent}
		onClick={close}
		>
			
			{/*


			*/}
			    
			      <form>
			        <FormGroup
			          controlId="formBasicText">
			          <FormControl
			            type="textarea"
			            value={this.state.terminalOut + this.state.value}
			            placeholder="Enter text"
			            onChange={this.handleChange.bind(this)}
			            onKeyDown={this.onKeyDown.bind(this)}
			          />
			          <FormControl.Feedback />
			          <HelpBlock>{this.state.terminalText}</HelpBlock>
			        </FormGroup>
			      </form>  
			      	{
			      		this.state.showWork ?
			          	 <WWorkExperience /> :
			           	null
			        }
			        {
			        	this.state.showEducation ?
			           		<EEducation /> :
			           	null
			        }
			        {
			        	this.state.showProject ?
			           		<PProjects /> :
			           	null
			        }
			        {
			        	this.state.showSkills ?
			           		<SSkills /> :
			           	null
			        }
			        {
			        	this.state.showWarning ?
			        	<div style={{ height: 120 }}>
						    <Popover
						      id="popover-basic"
						      placement="right"
						      positionLeft={200}
						      positionTop={50}
						      title="Hey, you got something wrong"
						      bsStyle="popover warning"
						    >
						      Try
						      <p>W for Work experience</p>
						      <p>S for skills</p>
						      <p>P for Projects</p>
						      <p>E for Educaion</p>
						      <p>And do not worry about backspaces, just keep typing</p>
						    </Popover>
						  </div> :
			        	null
			        }			   

		</Panel>
		</div>
		);
}
}


// WEBPACK FOOTER //
// ./src/Modal.js